<!-- <div class="main-background">
  <div class="container" id="container">

    <div class="form-container sign-up-container">

      <form action="#">

        <h1 style="color: #FD5924;">Create One</h1>

        <span></span>
        <input style="border-radius: 10px;" type="text" placeholder="Name" />
        <input style="border-radius: 10px;" type="email" placeholder="Email" />
        <input style="border-radius: 10px;" type="tel" placeholder="Mobile Number" />
        <input style="border-radius: 10px;" type="password" placeholder="Password" />
        <button>Continue</button>
      </form>
    </div>
    <div class="form-container sign-in-container">
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <h1 style="color: #FD5924;">Login to your account</h1>
        <div>
          <input style="border-radius: 10px;" type="text" placeholder="Username" formControlName="username" />
          <div *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched" style="color:red;">
            Username is required
          </div>
        </div>
        <div>
          <input style="border-radius: 10px;" type="password" placeholder="Password" formControlName="password" />
          <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" style="color:red;">
            Password is required
          </div>
        </div>
        <div class="link-row">
          <a style="color: #FD5924;" href="#">Forgot your password?</a>
          <a style="color: #FD5924;" href="#">Login as guest</a>
        </div>
        <button type="submit" [disabled]="loginForm.invalid">Log In</button>
      </form>
    </div>
    <div class="overlay-container">
      <div class="overlay">
        <div class="overlay-panel overlay-left">

          <h1>Welcome Back!</h1>
          <p>To keep connected with us please login with your personal info</p>
          <button class="ghost" id="signIn">Log In</button>
        </div>
        <div class="overlay-panel overlay-right">
          <h1>Hello!</h1>
          <p>Enter your personal details and start journey with us</p>
          <button class="ghost" id="signUp">CreateOne</button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class=" main_Hero1">
  <div class=" Hero">
    <div class=" Hero">
      <div class="container">
        <div class="heroContent">
<div class="hero-logo">
    <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid">
</div>


          <div class="main-content">
            <h6>INDIA’S FIRST HYBRID</h6>
            <h2>Finance, Property, Freedom<br>
              Together.</h2>
            <p>Get home loans, school EMIs, instant credit, and goal-based savings— all in one seamless and powerful app
              experience.</p>
          </div>
          <div class=" login-box p-5 shadow">
            <h2>Sign in to Nishwik</h2>
            <!-- <button class="google-btn"><img src="./images/google.png" width="18" alt="G" />Continue with Google</button>
            <div class="divider">or</div> -->

            <!-- LOGIN USING USER NAME AND PASSWORD -->
            <form *ngIf="!isMobileLogin" [formGroup]="loginForm" (ngSubmit)="onLogin()">
              <div class="form-group">
                <label for="email">Registered UserName</label>
                <input type="email" id="email" placeholder="username" formControlName="username">
                <div *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
                  style="color:red;">
                  Username is required
                </div>
              </div>

              <div class="form-group">
                <label for="password">Password</label>
                <input type="password" id="password" placeholder="Password" formControlName="password">
                <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                  style="color:red;">
                  Password is required
                </div>
              </div>

              <div class="row-options">
                <label><input type="checkbox"> Remember Me?</label>
                <a href="/reset-password">Reset Password?</a>
              </div>

              <button class="login-btn" [disabled]="loginForm.invalid">Login</button>
            </form>


            <!-- LOGIN USING MOBILENO AND OTP -->
            <form *ngIf="isMobileLogin && !isOtpSent" [formGroup]="mobileForm">
              <div class="form-group">
                <label for="mobile">Mobile Number</label>
                <input type="tel" id="mobile" placeholder="Enter mobile number" formControlName="mobileNo">
                <div class="error text-danger" *ngIf="mobileForm.get('mobileNo')?.invalid && mobileForm.get('mobileNo')?.touched">Enter
                  a valid 10-digit Indian mobile number</div>
              </div>
              <button class="login-btn" [disabled]="mobileForm.invalid || loading" (click)="sendOtp()">Send
                OTP</button>
            </form>

            <!-- AFTER OTP IS SENT -->
            <div *ngIf="isOtpSent" class="otp-section">

              <label class="text-success mb-3 fs-6 d-block text-center">
                {{ maskedMessage }}
              </label>

              <form [formGroup]="otpForm" novalidate>
                <div class="otp-boxes mb-3">
                  <input id="otp1" maxlength="1" class="otp-input" formControlName="otp1"
                    (input)="onOtpInput($event, 1)">
                  <input id="otp2" maxlength="1" class="otp-input" formControlName="otp2"
                    (input)="onOtpInput($event, 2)">
                  <input id="otp3" maxlength="1" class="otp-input" formControlName="otp3"
                    (input)="onOtpInput($event, 3)">
                  <input id="otp4" maxlength="1" class="otp-input" formControlName="otp4"
                    (input)="onOtpInput($event, 4)">
                  <input id="otp5" maxlength="1" class="otp-input" formControlName="otp5"
                    (input)="onOtpInput($event, 5)">
                  <input id="otp6" maxlength="1" class="otp-input" formControlName="otp6"
                    (input)="onOtpInput($event, 6)">
                </div>

                <div class="row-options fs-6" >
                  <label class="text-danger mb-0">{{ timerSeconds > 0 ? (timerSeconds | number:'2.0-0') + 's' : ''
                    }}</label>

                    <div [ngbTooltip]="resendOtpDisabled ? 'Please wait to receive OTP before trying again' : ''">

                      <a [class.disabled]="resendOtpDisabled" (click)="!resendOtpDisabled && resendOtp()"
                        [attr.title]="resendOtpDisabled ? 'Please wait to receive OTP before trying again' : ''"
                        
                        >
                        Resend OTP
                      </a>
                    </div>
                </div>

                <button type="button" class="login-btn" [disabled]="otpForm.invalid" (click)="verifyOtp()">Verify & Login</button>
              </form>
            </div>



            <div style="text-align:center;" *ngIf="isOtpSent">
              <label class="text-primary mb-0" style="font-size:15px; cursor:pointer;" (click)="changeMobileNo()">
                Change Mobile Number
              </label>
            </div>

            <div class="divider-line mt-0">
              <span>or</span>
            </div>

            <div>
              <button type="button" class="login-btn" (click)="toggleLoginMode()">
                <i class="fas fa-phone me-2" *ngIf="!isMobileLogin" ></i>
                <i class="fas fa-envelope me-2" *ngIf="isMobileLogin" ></i>
                {{ isMobileLogin ? 'Login with Email' : 'Login Via OTP' }}
              </button>
            </div>

            <div class="bottom-text">
              don’t have an account? <br> <a href="/signup">Create Account</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="login-footer">
  <div class="container d-flex justify-content-center gap-4">
    <a routerLink="/policy/privacy">Privacy Policy</a>
    <a routerLink="/policy/terms">Terms & Conditions</a>
    <a routerLink="/policy/cancellation">Cancellation Policy</a>
    <a routerLink="/policy/refund">Refund Policy</a>
    <a routerLink="/policy/contact">Contact us</a>
  </div>
</footer>
